import { useContext, type ComponentProps } from 'react';
import { ThemeContext } from 'styled-components';
import CarIcon from './CarIcon';

/** Vehicle glyph for a call that has both a primary and a secondary location. */
export default function AssociatedCarIcon(
  props: ComponentProps<typeof CarIcon>,
) {
  const theme = useContext(ThemeContext);
  return <CarIcon {...props} color={theme?.colors?.lightWarning} />;
}
